module.exports = __webpack_public_path__ + "img/addressLogo.541bca20.png";